// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class PreviewModal extends JQueryView {
  constructor() {
    super('.modal');
  }

  @on({ event: 'shown.bs.modal', selector: 'self' })
  removeReadmoreClass() {
    const row = 6;
    const lineHeight = 28;
    const fieldHeight = row * lineHeight;

    if ($('#thought-content').height() <= fieldHeight) {
      $('#thought-readmore').removeClass('readmore');
      $('#check1').hide();
    }

    if ($('#introduction-content').height() <= fieldHeight) {
      $('#introduction-readmore').removeClass('readmore');
      $('#check2').hide();
    }

    if ($('#destination-content').height() <= fieldHeight) {
      $('#destination-readmore').removeClass('readmore');
      $('#check3').hide();
    }
  }
}
